import axios from "axios";
import {
  backtestServicesURL,
  walletServicesURL,
} from "../constants/serviceUrls";

const instance = axios.create({
  timeout: 40000,
});

export default instance;

instance.interceptors.request.use(
  async (config: any) => {
    const { service, url } = config;

    const baseURL =
      process.env.NODE_ENV !== "production"
        ? "https://api.staging.saber.money/api/"
        : "https://api.staging.saber.money/api/";

    config.baseURL = baseURL;

    if (serviceIdentifier(service)?.includes("price")) {
      config.headers["X-Price-Client-Token"] =
        "528efb3b-582a-4b37-bf38-e4e9718d29a1";
    }
    config.headers["X-Platform"] = "web";
    config.headers["Access-Control-Allow-Origin"] =
      process.env.NODE_ENV !== "production"
        ? "https://edd.staging.saber.money"
        : "https://edd.staging.saber.money";
    config.headers["Access-Control-Allow-Methods"] =
      "DELETE, POST, GET, OPTIONS, PATCH";
    config.headers["Access-Control-Allow-Headers"] =
      "Content-Type, Authorization, X-Requested-With";
    config.headers["X-Device-Id"] = "web-user";
    config.headers["X-Authentication"] = sessionStorage.getItem("authToken");

    const constructedURL = serviceIdentifier(service) + url;
    config.url = constructedURL;

    return config;
  },
  (error) => Promise.reject(error)
);

const serviceIdentifier = (service: string) => {
  switch (service) {
    case "wallet":
      return walletServicesURL;
    default:
      return backtestServicesURL;
  }
};
